import SideBar from "./SideBar";
import "../blocks/profile/profile.css";
import GallerySection from "./GallerySection";
import GalleryMigrationBanner from "./GalleryMigrationBanner";

const GalleryPage = ({
  userName,
  userAvatar,
  userId,
  galleryItems,
  onCreateGallery,
  onDeleteGalleryItem,
  onSelectGalleryItem,
  onEditProfile,
  onLogout,
  onMigrated,
}) => {
  return (
    <div className="profile__section">
      <SideBar
        userName={userName}
        userAvatar={userAvatar}
        onEditProfile={onEditProfile}
        onLogout={onLogout}
      />
      <div className="profile__main-column">
        <GallerySection
          galleryItems={galleryItems}
          onCreateGallery={onCreateGallery}
          onDeleteGalleryItem={onDeleteGalleryItem}
          onSelectGalleryItem={onSelectGalleryItem}
        />
        <GalleryMigrationBanner userId={userId} onMigrated={onMigrated} />
      </div>
    </div>
  );
};

export default GalleryPage;
